import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=b9601d50&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports